import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {Scan3dModel} from '../../../api/entity/scan3d.model';
import {Scan3dConverter} from '../../../api/entity/converter/scan3d.converter';
import {Scan3dDataService} from './scan3dData.service';

@Injectable()
export class Scan3dDataServiceAdapter extends AbstractDataServiceDtoAdapter<Scan3dModel, Scan3dConverter> {
    constructor(dataService: Scan3dDataService, converter: Scan3dConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): Scan3dModel {
        return new Scan3dModel();
    }
}
